import { inject, Pipe, PipeTransform } from '@angular/core';
import { CommonFunctionsService } from 'app/services/common-functions/common-functions.service';

@Pipe({
  name: 'sentenceCase'
})
export class SentenceCasePipe implements PipeTransform {
  private commonFunctionsService: CommonFunctionsService = inject(CommonFunctionsService);

  transform(value: string | undefined): string {
    return this.commonFunctionsService.toSentenceCase(value);
  }
}
